import React from 'react'

export const Modal = ({ open, onClose, title, children, footer, className = '' }) => {
  if (!open) return null

  // Определяем, является ли title кастомным элементом
  const isCustomTitle = title && typeof title !== 'string'

  // Извлекаем max-w класс из className или используем дефолтный
  const hasCustomMaxW = /max-w-/.test(className)
  const maxWClass = hasCustomMaxW ? '' : 'max-w-xl'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* фон */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      {/* окно */}
      <div className={`relative w-full ${maxWClass} rounded-2xl bg-white dark:bg-slate-900 dark:text-slate-100 shadow-xl mx-auto max-h-[90vh] flex flex-col ${className}`}>
        {title && (
          <div className={`flex-shrink-0 ${isCustomTitle ? 'p-6 border-b border-gray-200 dark:border-slate-700' : 'p-6 pb-4'}`}>
            {typeof title === 'string' ? (
              <h2 className="text-lg font-semibold">{title}</h2>
            ) : (
              title
            )}
          </div>
        )}
        <div className="flex-1 overflow-y-auto px-6 py-4 min-h-0">
          <div className="space-y-3">{children}</div>
        </div>
        {footer && (
          <div className="flex-shrink-0 px-6 py-4 border-t border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800/50 rounded-b-2xl">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
